import { GitPullRequest, GitPullRequestDraft } from 'lucide-react';
import { EmptyState } from '../ui/EmptyState';
import { formatRelativeTime } from '../../utils/format';
import type { GitHubPullRequest } from '../../types';

export function PullRequestList({ pullRequests }: { pullRequests: GitHubPullRequest[] }) {
  if (pullRequests.length === 0) {
    return <EmptyState icon={GitPullRequest} title="No open pull requests" description="All caught up across tracked repositories." />;
  }

  return (
    <ul className="divide-y divide-slate-100 dark:divide-slate-800">
      {pullRequests.map((pr) => (
        <li key={pr.id} className="flex items-center gap-3 py-3">
          {pr.isDraft ? (
            <GitPullRequestDraft size={16} className="shrink-0 text-slate-400" />
          ) : (
            <GitPullRequest size={16} className="shrink-0 text-pulse-500" />
          )}
          <div className="min-w-0 flex-1">
            <a
              href={pr.htmlUrl}
              target="_blank"
              rel="noreferrer"
              className="block truncate text-sm font-medium text-slate-800 hover:text-pulse-600 dark:text-slate-200 dark:hover:text-pulse-400"
            >
              {pr.title}
            </a>
            <p className="mt-0.5 text-xs text-slate-400">
              {pr.repo} #{pr.number} &middot; {pr.author} &middot; updated {formatRelativeTime(pr.updatedAt)}
            </p>
          </div>
        </li>
      ))}
    </ul>
  );
}
